'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();

import type React from 'react'
import { useCallback } from 'react'

import { useCalendly } from '@/components/integrations/calendly/calendly-provider'
import { DropdownDescription, DropdownItem, DropdownLabel } from '@/components/ui/dropdown'

type CalendlyMenuItemProps = {
  label: string
  description?: string
  user?: string | null
  className?: string
  icon?: React.ReactNode
}

export function CalendlyMenuItem({ label, description, user, className, icon }: CalendlyMenuItemProps) {
  const { open, warmup } = useCalendly()

  const handleClick = useCallback(() => {
    open({ user, location: 'nav-menu' })
  }, [open, user])

  return (
    <DropdownItem onClick={handleClick} onPointerEnter={warmup} onFocus={warmup} className={className}>
      {icon}
      <DropdownLabel>{label}</DropdownLabel>
      {description ? <DropdownDescription>{description}</DropdownDescription> : null}
    </DropdownItem>
  )
}
